import { TranslationKeys } from '@/localization';
import { toRuntimeTranslationKey } from '@/localization/translationKey';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type BadgeWithDotProps = {
  dotColorClassName: string;
  label: TranslationKeys;
};

export const BadgeWithDot: FC<BadgeWithDotProps> = ({ dotColorClassName, label }) => {
  const { t } = useTranslation();
  const labelKey = toRuntimeTranslationKey(label);

  return (
    <div className='h-fit rounded-md border border-gray-150 px-1.5 py-0.5'>
      <p className='flex items-center gap-1 text-xs font-medium lowercase text-gray-650'>
        <span className={twMerge('inline-block size-2 rounded-full', dotColorClassName)}></span>
        <span className='first-letter:capitalize'>{t(labelKey as any)}</span>
      </p>
    </div>
  );
};
